module.exports = __webpack_public_path__ + "img/1531586056.0593948b.jpg";